var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row justify-content-center align-items-center"},_vm._l((_vm.numberOfPages),function(page){return _c('div',{key:page,staticClass:"location-marker rounded-circle",class:{ 'bg-primary': page === _vm.pageShowing, 'bg-gray-400': page !== _vm.pageShowing}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }